var React = require('react');

function CloseDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.647 7.34 6.353 19.616m11.294 0L6.353 7.34","stroke":"#323643","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CloseDark.defaultProps = {"width":"24","height":"27","viewBox":"0 0 24 27"};

module.exports = CloseDark;

CloseDark.default = CloseDark;
